import { categories } from '../constants';
import { getChartData } from '../provider';
import { MedisanteOrgReport } from '../types';

export const getSyncData = (reports: MedisanteOrgReport[]) => {
  const ok = reports.reduce((agg, report) => agg + report.syncScheduleOK, 0);
  const critical = reports.reduce(
    (agg, report) => agg + report.syncScheduleCritical,
    0
  );

  return {
    totalCount: ok + critical,
    okCount: ok,
    criticalCount: critical,
    chartData: [
      getChartData(categories.OK, ok),
      getChartData(categories.CRITICAL, critical),
    ],
  };
};
